import SvgIconBuilder from "./SvgIconBuilder";
import VehicleTypeCategorySvgIcons from "./VehicleTypeCategorySvgIcons";
class MarkerSmallBuilder extends SvgIconBuilder {
    static boxBackground = '<g id="boxBackground"><polygon fill="' + SvgIconBuilder.fgColourPlaceholder + '" points="15.9,32.2 10.8,25.8 0,25.5 0,-0.1 32,0 32,25.6 21.1,25.8"/></g>';
    static boxBorder = '<g id="boxBorder"><path fill="#231F20" d="M30.8,1v23.6L21,24.8l-0.5,0l-0.3,0.4l-4.4,5.4l-4.2-5.4l-0.3-0.4l-0.5,0l-9.8-0.1V1H30.8 M31.8,0H0.1v25.6l10.8,0.2l5,6.4l5.1-6.4l10.7-0.2V0L31.8,0z"/></g>';
    constructor() {
        super(32, 32, 32, 32);
    }
    static newMarker() {
        return new MarkerSmallBuilder();
    }
    static buildMarker(driverLocation) {
        const vehicleTypeCategoryName = driverLocation.vehicle && driverLocation.vehicle.type && driverLocation.vehicle.type.category.name;
        const vehicleIcon = VehicleTypeCategorySvgIcons.svgIconFromVehicleTypeCategoryName(vehicleTypeCategoryName);
        return MarkerSmallBuilder.newMarker()
            //
            // Small icon assumes it's a contractor since the large marker is always used for employees
            .appendColoured(MarkerSmallBuilder.boxBackground, SvgIconBuilder.white, SvgIconBuilder.lightGrey)
            .appendLayer(MarkerSmallBuilder.boxBorder)
            .appendColoured(vehicleIcon.smVehicleBody, SvgIconBuilder.coral, SvgIconBuilder.lightCoral)
            .appendLayer(vehicleIcon.smContractorC)
            .appendLayer(vehicleIcon.smWheelsStopped)
            .build();
    }
}
export default MarkerSmallBuilder;
